import { FC, Fragment, TextareaHTMLAttributes } from "react";
import { ExclamationCircleIcon } from "@heroicons/react/20/solid";

export type TextAreaprops = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  label: string;
  htmlFor?: string;
  spanMessage?: string;
  textError?: string;
  error?: boolean;
};

export const TextArea: FC<TextAreaprops> = ({
  label,
  htmlFor,
  spanMessage,
  textError,
  error,
  ...props
}) => {
  return (
    <Fragment>
      <div>
        <div className="flex justify-between">
          <label
            htmlFor={htmlFor}
            className="block text-sm font-medium leading-6 text-gray-900"
          >
            {label}
          </label>
          <span className="text-sm leading-6 text-gray-500">{spanMessage}</span>
        </div>
        <div className="relative">
          <textarea
            {...props}
            className={`px-2 block w-full rounded-md border-0 py-1.5 text-gray-400 shadow-sm ring-1 ring-inset ${
              error === true
                ? "ring-red-300 placeholder:text-red-300"
                : "ring-gray-300 placeholder:text-gray-400"
            } focus:ring-2 focus:ring-inset ${
              error === true ? "focus:ring-red-500" : "focus:ring-primary-600"
            } disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-500 disabled:ring-gray-200 sm:text-sm sm:leading-6 resize-none`}
          />

          {error === true ? (
            <div className="pointer-events-none absolute top-2 right-2 flex items-start pr-0">
              <ExclamationCircleIcon
                aria-hidden="true"
                className="h-5 w-5 text-red-500"
              />
            </div>
          ) : null}
        </div>

        {error === true ? (
          <>
            <p className={`mt-1 text-sm text-red-600`}>{textError}</p>
          </>
        ) : null}
      </div>
    </Fragment>
  );
};